module.exports = __webpack_public_path__ + "static/media/sumofame-logo@1.5x.5bc826f0.png";